import React from 'react';
import moment from 'moment';
import { TableRow, TableCell, Button } from '@mui/material';
import Formatter from '../../utils/Formatter';

const Breakdown = ({ loans, plan }) => {
  return loans.map((eachLoan) => {
    const forgiveness = plan.forgiveness.filter(
      (id) => id.loanId == eachLoan.id
    );
    const outstandingBalance = plan.outstandingBalance.filter(
      (id) => id.loanId == eachLoan.id
    );
    const mmp = plan.mmp.filter((id) => id.loanId == eachLoan.id);
    const subsidy = plan.subsidy.filter((id) => id.loanId == eachLoan.id);
    const periods = plan.periods.filter((id) => id.loanId == eachLoan.id);
    const payoff = plan.payoff.filter((id) => id.loanId == eachLoan.id);
    const lastPaymentYear = plan.lastPaymentYear.filter(
      (id) => id.loanId == eachLoan.id
    );

    return (
      <TableRow key={eachLoan.id} className="current-repayment">
        <TableCell colSpan={2}>
          <span className="">
            &nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
          {eachLoan.type.name}
        </TableCell>
        <TableCell>${Formatter.money(mmp[0].value)}</TableCell>
        <TableCell>${Formatter.money(subsidy[0].value)}</TableCell>
        <TableCell>${Formatter.money(forgiveness[0].value || outstandingBalance[0].value)}</TableCell>
        <TableCell>{periods[0].value}</TableCell>
        <TableCell>${Formatter.money(payoff[0].value)}</TableCell>
        <TableCell>{lastPaymentYear[0].value}</TableCell>
        <TableCell></TableCell>
      </TableRow>
    );
  });
};

export default Breakdown;
